
<div>
    <f-dialog
        v-model       = "edit"
        :width        = "600"
        :show-header  = "false"
        :hide-actions = "false"
        :store-label  = "$t('dms.props.store')"
        content-class = "dialog-border"
        @cancel       = "onCancel"
        @store        = "onStore"
    >
        <template v-slot:content>
            <div style="position: relative" class="pl-2">
                <div class="close-button">
                    <c-toolbar-button
                        size     = "28"
                        color    = "red"
                        icon     = "mdi-close"
                        :tooltip = "$t('common.cancel')"
                        @click   = "onCancel"
                    />
                </div>


                    <v-switch
                        :ripple = "false"
                        v-model="allunits"
                    >
                        <template v-slot:label>
                            <div style="    font-size: 15px; font-weight: 600 ">
                                {{ allunits ? $t('dms.props.assign.all') :  $t('dms.props.assign.unit', [ unit.fabricNo ]) }}
                            </div>
                        </template>
                    </v-switch>

                <div class="v-flex">
                    <f-enum-select
                        v-model  = "type"
                        label    = "Dokumentenart"
                        module   = "inc"
                        type     = "stepdoctypes"
                        :exclude = "exclude"
                    />
                    <v-switch
                        v-if    = "isPrivileged"
                        class   = "ml-2"
                        v-model = "force"
                        :ripple = "false"
                    >
                        <template v-slot:label>
                            <v-icon size="22" color="primary">mdi-content-save-move</v-icon>
                        </template>
                    </v-switch>
                </div>

                <div class="v-flex">
                    <v-text-field
                        label = "Dateiname"
                        v-model="filename"
                    />
                    <div class="file-extension">
                        {{ extension }}
                    </div>
                </div>
            </div>
        </template>
    </f-dialog>
</div>
